export const myQRListStyles = {
  // QR List Card:
  qrListCard: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    marginVertical: 1,
    alignItems: "center",
    cursor: "pointer",
  },
  qrListContainer: {
    display: "flex",
    flexDirection: "column",
    borderBottom: "0.5px solid #8D8D8D",
    flex: 1,
    paddingBottom: 1,
  },
  qrListMainText: {
    fontSize: "17px",
    fontWeight: "600",
    color: "#000",
  },
  qrListSubText: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#000",
    paddingRight: "5px",
  },
  qrListText: {
    fontSize: "13px",
    fontWeight: "400",
    color: "#000",
  },
  qrListDetailsCard: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  // selected qr:
  qrDetailsContainer: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: "center",
    gap: "50px",
    marginTop: 5,
  },
  qrContainer: {
    display: "flex",
    justifyContent: { xs: "center", sm: "flex-end" },
  },
  qrDetails: {
    display: "flex",
    flexDirection: "column",
    justifyContent: { xs: "center", sm: "flex-start" },
    alignItems: { xs: "center", sm: "flex-start" },
    textAlign: { xs: "center", sm: "flex-start" },
    gap: 2,
  },
  actionButton: {
    color: "black",
    border: "1px solid black",
    "&:hover": {
      backgroundColor: "transparent",
      borderColor: "black",
    },
    width: "300px",
    paddingX: "50px",
    paddingY: "5px",
    fontSize: "15px",
  },
  mainHeading: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#000",
  },
  subHeading: {
    fontSize: "17px",
    fontWeight: "400",
    color: "#000",
  },
};
